const STEPS = [
  {
    n: "01",
    title: "Enquire",
    copy: "Tell Carly a little about your pet, the service you are looking for and the dates or regular days you need.",
    img: "/images/marypawpins/lab-paw-handshake-view.jpg",
  },
  {
    n: "02",
    title: "Have a chat",
    copy: "Carly will discuss availability, routines, temperament and any important care requirements.",
    img: "/images/marypawpins/carly-cockapoo-selfie.jpg",
  },
  {
    n: "03",
    title: "Meet & greet",
    copy: "A free, relaxed introduction gives everyone the opportunity to get acquainted and discuss the practical details.",
    img: "/images/marypawpins/fox-red-lab-handshake.jpg",
  },
  {
    n: "04",
    title: "Confirm your booking",
    copy: "Once the service is agreed, Carly will confirm the arrangements, relevant information and next steps.",
    img: "/images/marypawpins/duo-running-viaduct.jpg",
  },
];

export const Steps = () => (
  <section className="py-16 sm:py-24 bg-[#E7E2D8]/60" data-testid="steps-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="eyebrow">How it works</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight mt-4" data-testid="steps-heading">
            Getting started.
          </h2>
        </div>
        <p className="text-sm text-[#575953] max-w-xs sm:text-right">
          A calm, unhurried process. No instant bookings, no pressure.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((s) => (
          <div key={s.n} className="relative bg-[#F7F4ED] rounded-3xl p-4 border border-[#DDD7CB]" data-testid={`step-${s.n}`}>
            <img src={s.img} alt="" loading="lazy" className="rounded-2xl w-full aspect-[16/10] object-cover" />
            <div className="p-3">
              <span className="font-serif text-4xl text-[#B9A58D]">{s.n}</span>
              <h3 className="mt-3 font-serif text-xl font-medium text-[#292A26]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#575953]">{s.copy}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
